import { Component, OnDestroy, OnInit, DoCheck } from '@angular/core';
import { ICardComponent } from '../../ICardComponent';
import { WorkflowComponent } from '../../workflow.component';


@Component({
    selector: 'documentation-help',
    templateUrl: './documentation-help.component.html',
    standalone: false
})
export class DocumentationHelpComponent implements OnInit, OnDestroy, ICardComponent, DoCheck{

  cardData: any;
  cardConfiguration: models.CardVM;
//  getWorkflowNeedsRevision?(): models.SendWorkflowVM {
      //throw new Error("Method not implemented.");
//  }
  isWorkflowOnSubscriber?: boolean;
  isWorkflowMandatory?: boolean;
  isWorkflowPgpv?: boolean;
  isWorkflowPgpt?: boolean;
  cardExternalValidationErrors?: models.WorkflowValidationErrorVM[];
  isWorkflowAgeLimit?: boolean;
  disableTableRemoveIcons?: boolean;
  parentWorkflow?: WorkflowComponent;
  isWorkflowIncapacity?: boolean;



  ngOnInit(): void { }

  ngDoCheck(): void { }


  ngOnDestroy(): void {
  }





}
